jQuery(document).ready(function ($) {
  //

  $('.btn-remover-alerta').click(function (event) {
    var btn = $(this)
    var btnHtml = btn.html()
    btn.html('<i class="fa fa-spin fa-spinner"></i> Aguarde...')

    swal(
      {
        title: 'Confirmar exclusão de alerta?',
        text: 'Confirme a exclusão do alerta: ' + $(event.currentTarget).closest('.alerta-item').find('.alerta-titulo').html(),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#DD6B55',
        confirmButtonText: 'Confirmar!',
        closeOnConfirm: true
      },
      function (isConfirm) {
        if (isConfirm) {
          btn.html('<i class="fa fa-spin fa-spinner"></i> Excluindo...')

          $.ajax({
            url: event.currentTarget.getAttribute('href'),
            type: 'DELETE',
            data: {
              _crsf: $('meta[name=csrf-token]').attr('content')
            }
          }).done(function () {
            btn.html(btnHtml)
            $(event.currentTarget)
              .closest('.alerta-item')
              .removerElemento(function () {
                if ($('.alerta-lista .alerta-item').length <= 1)
                  $('.alerta-lista').append(
                    '<div class="alerta-item center"><div href="" class="alerta-titulo">Nenhum alerta cadastrado.</div></div>'
                  )
              })
          })
        } else btn.html(btnHtml)
      }
    )

    return false
  })

  $('.alerta-acoes input').change(function (event) {
    $(this).parents('.alerta-acoes').find('input:checked').val()

    $.ajax({
      url: $(this).parents('.alerta-acoes').attr('data-url'),
      type: 'POST',
      data: {
        frequencia: $(this).parents('.alerta-acoes').find('input:checked').val()
      }
    }).done(function () {})
  })
})
